module.exports = __webpack_public_path__ + "static/media/icon-button-arrow-right-white.469befb8.svg";